import { gql } from '@apollo/client';

const CREATE_HELP_TOPIC = gql`mutation createHelpTopic($input: CreateHelpTopicInput!) {
  helpContext {
    createHelpTopic(input: $input) {
			success
			message
			topic {
				topicId: id
				parentTopicId: parentId
				index
				title: name
				description
			}
    }
  }
}`;

export default CREATE_HELP_TOPIC;
